/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/351/interface/api/cat_720
 */

import { message } from 'ant-design-vue'
import {
  portal_login_sign_in_get,
  portal_login_sign_out_get,
  portal_login_sign_by_password_get,
  portal_login_register_post,
  portal_login_simulate_confirm_get,
  portal_login_simulate_cancel_get
} from 'server/modules/720'

// 登录
export const portal_login_sign_in_get_ = async function(params) {
  const { success, data, retInfo } = await portal_login_sign_in_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 注销
export const portal_login_sign_out_get_ = async function(params) {
  const { success, data, retInfo } = await portal_login_sign_out_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 密码登入
export const portal_login_sign_by_password_get_ = async function(params) {
  const { success, data, retInfo } = await portal_login_sign_by_password_get(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 注册
export const portal_login_register_post_ = async function(params) {
  const { success, data, retInfo } = await portal_login_register_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 模拟登录确认
export const portal_login_simulate_confirm_get_ = async function(params) {
  const { success, data, retInfo } = await portal_login_simulate_confirm_get(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 模拟登录取消
export const portal_login_simulate_cancel_get_ = async function(params) {
  const { success, data, retInfo } = await portal_login_simulate_cancel_get(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}
